const link = process.env.REACT_APP_SERVER_API_V1

const getRefreshTokenUrl = () => `${link}/authorization/refresh-token`

export default getRefreshTokenUrl
